import { useState, useEffect } from 'react'
import { Link } from 'react-router-dom'
import Logo from './Logo'

const G = {
  white:   '#FFFFFF',
  ink:     '#0A0A0A',
  blue:    '#4F8EF7',
  blueD:   '#3A7AE0',
  display: "'Barlow Condensed', sans-serif",
  body:    "'Space Grotesk', sans-serif",
  mono:    "'Space Grotesk', sans-serif",
}

const STRINGS = {
  FR: {
    pricing:  'Tarifs',
    about:    'À propos',
    blog:     'Blog',
    contact:  'Contact',
    login:    'Connexion',
    cta:      'Créer mon compte',
    menuLbl:  'Menu de navigation',
    langLbl:  'Changer de langue',
  },
  EN: {
    pricing:  'Pricing',
    about:    'About',
    blog:     'Blog',
    contact:  'Contact',
    login:    'Log in',
    cta:      'Create my account',
    menuLbl:  'Navigation menu',
    langLbl:  'Change language',
  },
}

const NAV_CSS = `
@media (max-width: 900px) {
  .lnav-links, .lnav-auth, .lnav-lang { display: none !important; }
  .lnav-burger { display: flex !important; }
}
@media (max-width: 480px) {
  .lnav-bar { padding: 0 16px !important; }
}
`

const btnPrimary = {
  padding: '0 18px', minHeight: 38, background: G.ink, color: G.white,
  fontFamily: G.mono, fontSize: 13, fontWeight: 600,
  border: 'none', cursor: 'pointer', borderRadius: 3,
  textDecoration: 'none', display: 'inline-flex', alignItems: 'center', gap: 8,
}

const linkBase = {
  fontSize: 13, fontWeight: 500,
  color: 'rgba(0,0,0,0.55)',
  textDecoration: 'none',
  transition: 'color .15s',
  fontFamily: G.mono,
}

const mobileLink = {
  fontSize: 14, fontWeight: 500,
  color: 'rgba(0,0,0,0.65)',
  textDecoration: 'none',
  padding: '12px 0',
  borderBottom: '0.5px solid #EBEBEB',
  fontFamily: G.mono,
}

export const LANDING_NAV_HEIGHT = 72

export default function LandingNav({ lang = 'FR', onToggleLang }) {
  const [navScrolled, setNavScrolled] = useState(false)
  const [menuOpen, setMenuOpen]       = useState(false)
  const t = STRINGS[lang] || STRINGS.FR
  const showToggle = typeof onToggleLang === 'function'

  useEffect(() => {
    const onScroll = () => setNavScrolled(window.scrollY > 20)
    window.addEventListener('scroll', onScroll)
    return () => window.removeEventListener('scroll', onScroll)
  }, [])

  return (
    <>
      <style>{NAV_CSS}</style>

      <nav className="lnav-bar" style={{
        position: 'fixed', top: 0, left: 0, right: 0, zIndex: 200,
        background: G.white, borderBottom: '1.5px solid #0A0A0A', height: LANDING_NAV_HEIGHT,
        display: 'flex', alignItems: 'center', justifyContent: 'space-between',
        padding: '0 40px', boxSizing: 'border-box',
        boxShadow: navScrolled ? '0 2px 8px rgba(0,0,0,0.06)' : 'none',
        transition: 'box-shadow .2s',
      }}>
        <Link to="/" style={{ textDecoration: 'none' }}>
          <Logo variant="full" theme="light" size={36} />
        </Link>

        <div className="lnav-links" style={{ display: 'flex', gap: 28, alignItems: 'center' }}>
          <Link to="/tarifs" style={linkBase}
            onMouseEnter={e => e.currentTarget.style.color = G.ink}
            onMouseLeave={e => e.currentTarget.style.color = 'rgba(0,0,0,0.55)'}>
            {t.pricing}
          </Link>
          <Link to="/a-propos" style={linkBase}
            onMouseEnter={e => e.currentTarget.style.color = G.ink}
            onMouseLeave={e => e.currentTarget.style.color = 'rgba(0,0,0,0.55)'}>
            {t.about}
          </Link>
          <a href="/blog/" style={linkBase}
            onMouseEnter={e => e.currentTarget.style.color = G.ink}
            onMouseLeave={e => e.currentTarget.style.color = 'rgba(0,0,0,0.55)'}>
            {t.blog}
          </a>
          <a href="/#contact" style={linkBase}
            onMouseEnter={e => e.currentTarget.style.color = G.ink}
            onMouseLeave={e => e.currentTarget.style.color = 'rgba(0,0,0,0.55)'}>
            {t.contact}
          </a>
        </div>

        {showToggle && (
          <button className="lnav-lang" onClick={onToggleLang} aria-label={t.langLbl} style={{
            background: 'rgba(0,0,0,0.04)', border: '1px solid rgba(0,0,0,0.12)',
            borderRadius: 4, padding: '5px 10px', cursor: 'pointer',
            display: 'flex', alignItems: 'center', gap: 6,
            transition: 'background .15s',
          }}
            onMouseEnter={e => e.currentTarget.style.background = G.blue + '1A'}
            onMouseLeave={e => e.currentTarget.style.background = 'rgba(0,0,0,0.04)'}>
            <span style={{ fontSize: 13 }}>{lang === 'FR' ? '🇫🇷' : '🇬🇧'}</span>
            <span style={{ fontFamily: G.mono, fontSize: 11, fontWeight: 600, letterSpacing: '.08em', color: 'rgba(0,0,0,0.7)' }}>{lang}</span>
          </button>
        )}

        <div className="lnav-auth" style={{ display: 'flex', gap: 10, alignItems: 'center' }}>
          <Link to="/login" style={{ ...linkBase, fontSize: 13 }}
            onMouseEnter={e => e.currentTarget.style.color = G.ink}
            onMouseLeave={e => e.currentTarget.style.color = 'rgba(0,0,0,0.55)'}>
            {t.login}
          </Link>
          <Link to="/signup" style={btnPrimary}
            onMouseEnter={e => e.currentTarget.style.background = G.blueD}
            onMouseLeave={e => e.currentTarget.style.background = G.ink}>
            {t.cta} →
          </Link>
        </div>

        <button className="lnav-burger" onClick={() => setMenuOpen(o => !o)}
          aria-label={t.menuLbl}
          style={{ display: 'none', background: 'none', border: 'none', cursor: 'pointer', flexDirection: 'column', gap: 5, padding: 4 }}>
          {[0,1,2].map(i => (
            <span key={i} style={{
              width: 22, height: 1.5, background: G.ink, display: 'block', transition: '.2s',
              transform: menuOpen && i===0 ? 'translateY(6.5px) rotate(45deg)' : menuOpen && i===2 ? 'translateY(-6.5px) rotate(-45deg)' : 'none',
              opacity: menuOpen && i===1 ? 0 : 1,
            }}/>
          ))}
        </button>
      </nav>

      <div style={{
        position: 'fixed', top: LANDING_NAV_HEIGHT, left: 0, right: 0, zIndex: 199,
        background: G.white, borderBottom: '0.5px solid #EBEBEB',
        padding: '16px 24px 20px', display: 'flex', flexDirection: 'column',
        transform: menuOpen ? 'translateY(0)' : 'translateY(-110%)',
        opacity: menuOpen ? 1 : 0,
        pointerEvents: menuOpen ? 'auto' : 'none',
        transition: 'transform .25s ease, opacity .2s ease',
      }}>
        <Link to="/tarifs" onClick={() => setMenuOpen(false)} style={mobileLink}>{t.pricing}</Link>
        <Link to="/a-propos" onClick={() => setMenuOpen(false)} style={mobileLink}>{t.about}</Link>
        <a href="/blog/" onClick={() => setMenuOpen(false)} style={mobileLink}>{t.blog}</a>
        <a href="/#contact" onClick={() => setMenuOpen(false)} style={mobileLink}>{t.contact}</a>
        {showToggle && (
          <div style={{ display: 'flex', gap: 8, alignItems: 'center', padding: '12px 0', borderBottom: '0.5px solid #EBEBEB' }}>
            <button onClick={onToggleLang} style={{
              background: 'rgba(0,0,0,0.04)', border: '1px solid rgba(0,0,0,0.12)',
              borderRadius: 4, padding: '5px 10px', cursor: 'pointer', display: 'flex', alignItems: 'center', gap: 6,
            }}>
              <span style={{ fontSize: 13 }}>{lang === 'FR' ? '🇫🇷' : '🇬🇧'}</span>
              <span style={{ fontFamily: G.mono, fontSize: 11, fontWeight: 600, letterSpacing: '.08em', color: 'rgba(0,0,0,0.7)' }}>{lang}</span>
            </button>
          </div>
        )}
        <Link to="/login" onClick={() => setMenuOpen(false)} style={mobileLink}>{t.login}</Link>
        <Link to="/signup" onClick={() => setMenuOpen(false)} style={{ ...btnPrimary, marginTop: 12, justifyContent: 'center' }}>{t.cta} →</Link>
      </div>
    </>
  )
}
